import React from 'react';
import { getIcon, ICON_OPTIONS } from '../../lib/icons';
import { EField, FieldRow } from './EditableField';

export default function SectionFeatures({ section_label = '', title = '', subtitle = '', items = [], mode = 'view', onChange }) {
  const upd = (i, k, v) => onChange?.({ items: items.map((it, idx) => idx === i ? { ...it, [k]: v } : it) });
  const add = () => onChange?.({ items: [...items, { icon: 'sparkles', title: 'Feature', description: 'Description' }] });
  const rem = (i) => onChange?.({ items: items.filter((_, idx) => idx !== i) });

  return (
    <section className="py-24 bg-ee-bg">
      <div className="ee-container">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          {mode === 'edit' ? (
            <>
              <FieldRow label="Section Label"><EField value={section_label} onChange={(v) => onChange?.({ section_label: v })} mode={mode} /></FieldRow>
              <FieldRow label="Title"><EField value={title} onChange={(v) => onChange?.({ title: v })} mode={mode} /></FieldRow>
              <FieldRow label="Subtitle"><EField multiline value={subtitle} onChange={(v) => onChange?.({ subtitle: v })} mode={mode} /></FieldRow>
            </>
          ) : (
            <>
              <div className="text-xs tracking-[0.3em] text-gold mb-3 uppercase">{section_label}</div>
              <h2 className="hero-title text-4xl md:text-5xl text-white mb-4">{title}</h2>
              <p className="text-ee-text2">{subtitle}</p>
            </>
          )}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => {
            const Icon = getIcon(it.icon);
            return (
              <div key={i} className="ee-card ee-card-hover p-6">
                <div className="w-12 h-12 rounded-lg bg-gold/10 border border-gold/20 flex items-center justify-center mb-4">
                  <Icon size={22} className="text-gold" />
                </div>
                <h3 className="text-lg font-serif text-white mb-2"><EField value={it.title} onChange={(v) => upd(i, 'title', v)} mode={mode} /></h3>
                <p className="text-ee-text2 text-sm leading-relaxed"><EField multiline value={it.description} onChange={(v) => upd(i, 'description', v)} mode={mode} /></p>
                {mode === 'edit' && (
                  <div className="mt-3 grid grid-cols-2 gap-2">
                    <FieldRow label="Icon">
                      <select value={it.icon} onChange={(e) => upd(i, 'icon', e.target.value)} className="w-full bg-ee-card2 border border-gold/30 rounded-md px-2 py-1 text-white">
                        {ICON_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
                      </select>
                    </FieldRow>
                    <div className="flex items-end"><button onClick={() => rem(i)} className="text-xs text-red-400">Remove</button></div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {mode === 'edit' && (
          <div className="text-center mt-6"><button onClick={add} className="text-xs px-3 py-1.5 rounded border border-gold/40 text-gold hover:bg-gold/10">+ Feature</button></div>
        )}
      </div>
    </section>
  );
}
